import { is } from "core-js/core/object"

const state = {
  all: [],
  actives: [],
 
 
}

const getters = {
  getAttributeById: (state) => (id) => {
    return state.all.find(attribute => attribute.id === id)
  }
}

const actions = {
  getAttributes ({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/admin/attributes")
        .then(response => {
          commit('setData', response.data)
          resolve(response)
        })
        .catch ( error => (reject(error)));
    })
  },
   getAccoRequestMessage ({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/getAccoRequestMessage")
      .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  isAccoRequestAvailable ({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/isAccoRequestAvailable")
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  addAttribute ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/attributes", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  editAttribute ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/attributes/"+params.id, params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getAttribute ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get("/admin/attributes/"+params.id, params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  setAttributes ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/attributes/setAttributes", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
}

const mutations = {
  setData (state, data) {
    state.all = data.data;
    state.actives = []
    _.forEach(state.all, (attribute) => {
      if (attribute.is_active == 1) {
        state.actives.push(attribute)
      }
    })
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
